
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="pageHeader" id="serviceTransfersListHeader">List of Servicer Transfers</div>

  <div class="appr-del-msg" *ngIf="approveTransferFlag && (approveDeleteFlag != null && approveDeleteFlag === 'approve')">

    <span>
      The following Transactions have been Approved Successfully.
    </span>

  </div>

  <div class="appr-del-msg" *ngIf="approveTransferFlag && (approveDeleteFlag != null && approveDeleteFlag === 'delete')">

    <span>
      The following transactions have been deleted successfully
    </span>

  </div>
  <div class="appr-del-msg" *ngIf="(approveDeleteFlag != null && approveDeleteFlag === 'approve') && !approveTransferFlag">

  <span>Do you really want to approve the transactions?</span>
</div>

  <div class="appr-del-msg" *ngIf="(approveDeleteFlag != null && approveDeleteFlag === 'delete') && !approveTransferFlag">

    <span>Do you really want to delete the transactions?</span>
  </div>

  <div *ngIf="approveDeleteServiceTransferList" class="u-scroll-x">
    <fm-table [columns]="cols" [value]="approveDeleteServiceTransferList"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">
            <span *ngIf="col.header==='Portfolio Indicator' && rowData[col.field]==='Partial'">
              <a class="detail-link" (click)="showLoanDetails(rowData)">{{rowData[col.field]}} </a>
            </span>

            <span *ngIf="col.header==='Effective Date' || col.header==='Receipt Date'"> {{(rowData[col.field])}}</span>
            <span *ngIf="col.header==='Status'"> {{(rowData[col.field]).code}}</span>

            <span *ngIf="(col.header!=='Portfolio Indicator' || rowData[col.field]!=='Partial')
                && col.header!=='Effective Date' && col.header!=='Receipt Date'
                && col.header!=='Status'"> {{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <div class="u-mb-150" *ngIf="!approveTransferFlag">
    <button fmButton type="submit" [primary]="true" [small]="true" label="Yes"
            (click)="confimrmApproveOrDelete()" class="buttonmargin"></button>

    <button fmButton type="button" (click)="cancelButton()" [primary]="true" label="No" [small]="true" class="buttonmargin"></button>
  </div>

</div>
